import {
  Skeleton
} from "antd";
import {
  FC,
  Fragment,
  useEffect,
  useState
} from "react";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

//!STYLES
import { isToday } from "common/enums";
import { useSelector } from "react-redux";
import { useGetHistoriqueOrganismQuery } from "store/services/teacher/classes.services";
import s from "../assets/calendar.module.css";

import AppResult from "components/appResults";
import CardReservations from "screens/organisme/classDetails/components/card";

interface ReservationsCalendarProps {
  setCalendarData: React.Dispatch<any>;
  filter?: any;
}

const CalendarOfReservationOrganism: FC<ReservationsCalendarProps> = ({ setCalendarData, filter }) => {

  const { user } = useSelector((state) => state.auth);
  const { isReservationsUpdated } = useSelector((state) => state.app);
  const [courses, setCourses] = useState<any>([]);

  const {
    data: reservations,
    isLoading,
    isError,
    refetch,
  } = useGetHistoriqueOrganismQuery({ organismeId: user?._id });

  const hasCourses = courses && Object.keys(courses).length > 0;

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1050);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 1050);
  };
  window.addEventListener('resize', handleResize);

  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    refetch();
  }, [isReservationsUpdated]);

  useEffect(() => {
    if (reservations) {
      setCalendarData(reservations?.data);
    }
  }, [reservations]);

  useEffect(() => {
    if (reservations?.data) {
      const groupedByDate = reservations?.data.reduce((acc: any, course: any) => {
        const date = new Date(course.startDate).toISOString().split("T")[0];
        if (!acc[date]) {
          acc[date] = [];
        }
        acc[date].push(course);
        return acc;
      }, {});

      setCourses(groupedByDate);
    }
  }, [reservations]);

  /* useEffect(() => {
    if (filter) {
      let filtered = courses;

      if (filter === 'all') {
        const groupedByDate = reservations?.data.reduce((acc: any, course: any) => {
          const date = new Date(course.startDate).toISOString().split("T")[0];
          if (!acc[date]) {
            acc[date] = [];
          }
          acc[date].push(course);
          return acc;
        }, {});

        setCourses(groupedByDate);
      }
      else {
        filtered = reservations?.data.filter(
          (session: any) =>
            session.classeId &&
            session.classeId === filter
        );

        const groupedByDate = filtered?.reduce((acc: any, course: any) => {
          const date = new Date(course.startDate).toISOString().split("T")[0];
          if (!acc[date]) {
            acc[date] = [];
          }
          acc[date].push(course);
          return acc;
        }, {});

        setCourses(groupedByDate);
      }
    }
  }, [filter]); */

  useEffect(() => {
    const groupByDate = (data: any[]) =>
      data?.reduce((acc: any, course: any) => {
        const date = new Date(course.startDate).toISOString().split('T')[0];
        if (!acc[date]) acc[date] = [];
        acc[date].push(course);
        return acc;
      }, {});

    if (!filter || filter.length === 0 || filter.includes('all')) {
      setCourses(groupByDate(reservations?.data));
      return;
    }

    const filtered = reservations?.data.filter(
      (session: any) => session.classeId && filter.includes(session.classeId)
    );

    setCourses(groupByDate(filtered));
  }, [filter]);

  return (
    <div>
      {isLoading ? (
        <>
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
        </>
      ) : (
        <Fragment>
          <div className={s.calendar}>
            {hasCourses ? (
              courses && Object.keys(courses).map((date) => (
                <div key={date} style={{ marginTop: "10px" }}>
                  <div className={s.dateBox}>
                    {new Intl.DateTimeFormat("fr-FR", {
                      weekday: "long",
                      day: "numeric",
                      month: "long",
                      year: "numeric",
                    }).format(new Date(date))}
                    {isToday(date) && <div className={s.todayBox}>Aujourd’hui</div>}
                    <div className={s.horizontalLine}></div>
                  </div>

                  {!isMobile &&
                    courses[date].map((course: any) => (
                      <div key={course.id}>
                        <CardReservations
                          course={course}
                          isHistorique={false}
                          teacher={undefined}
                          displayClasseName={true}
                        />
                      </div>
                    ))}

                  {isMobile && (
                    <div className={s.cardDisplay}>
                      {courses[date].map((course: any) => (
                        <div key={course.id}>
                          <CardReservations
                            course={course}
                            isHistorique={false}
                            teacher={undefined}
                            displayClasseName={true}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))
            ) : (
              <div className={s.emptyClass}>
                <AppResult status="info" title="Aucune séance" />
              </div>
            )}
          </div>
        </Fragment>
      )}
    </div>
  );
};

export default CalendarOfReservationOrganism;
